/** Referentie uit een geslaagde serveractie, nooit uit modelparameters. */
export interface OfferteInhoud {
  pakketSku: string;
  kleden: Array<{ sku: string; lengteCm: number | null; breedteCm: number | null; diameterCm: number | null; oppervlakteM2: number }>;
  behandelingen: Array<{ sku: string; prijsInclBtw: number }>;
  basisInclBtw: number;
  totaalInclBtw: number;
}
export interface OfferteBewijs { id: string; nummer: string; url: string; inhoud?: OfferteInhoud }

export function leesOfferteBewijs(raw: unknown): OfferteBewijs | undefined {
  if (!raw || typeof raw !== 'object') return undefined;
  const o = raw as Record<string, unknown>;
  if (typeof o.id !== 'string' || !/^(?:[a-zA-Z0-9]{15}(?:[a-zA-Z0-9]{3})?|eigen-[0-9a-f-]{36})$/.test(o.id)
    || typeof o.nummer !== 'string' || !/^L-\d+$/.test(o.nummer)
    || typeof o.url !== 'string' || !/^https:\/\/offerte\.kleda\.nl\/\?token=[a-f0-9]{64}$/.test(o.url)) return undefined;
  let inhoud: OfferteInhoud | undefined;
  if (o.inhoud !== undefined) {
    const i = o.inhoud as OfferteInhoud;
    const positief = (n: unknown) => typeof n === 'number' && Number.isFinite(n) && n > 0;
    if (!i || i.pakketSku !== 'WAS-PACK-VLOERKLEED-BASIS' || !positief(i.basisInclBtw) || !positief(i.totaalInclBtw)
      || !Array.isArray(i.kleden) || !i.kleden.length || i.kleden.length > 20 || i.kleden.some(k => !k || k.sku !== 'WAS-PRIM-VLOERKLEED-REINIGEN' || !positief(k.oppervlakteM2)
        || (k.diameterCm != null ? !positief(k.diameterCm) || k.lengteCm !== null || k.breedteCm !== null : !positief(k.lengteCm) || !positief(k.breedteCm)))
      || !Array.isArray(i.behandelingen) || i.behandelingen.some(b => !b || typeof b.sku !== 'string' || !/^WAS-EXTRA-VLOERKLEED-[A-Z]+$/.test(b.sku) || !positief(b.prijsInclBtw))
      || new Set(i.behandelingen.map(b => b.sku)).size !== i.behandelingen.length
      || Math.round(i.totaalInclBtw * 100) !== Math.round(i.basisInclBtw * 100) + i.behandelingen.reduce((n, b) => n + Math.round(b.prijsInclBtw * 100), 0)) return undefined;
    inhoud = { pakketSku: i.pakketSku, basisInclBtw: i.basisInclBtw, totaalInclBtw: i.totaalInclBtw,
      kleden: i.kleden.map(k => ({ sku: k.sku, lengteCm: k.lengteCm, breedteCm: k.breedteCm, diameterCm: k.diameterCm, oppervlakteM2: k.oppervlakteM2 })),
      behandelingen: i.behandelingen.map(b => ({ sku: b.sku, prijsInclBtw: b.prijsInclBtw })) };
  }
  return { id: o.id, nummer: o.nummer, url: o.url, ...(inhoud ? { inhoud } : {}) };
}

export function offerteAanmaakBewijs(verb: string, body: Record<string, unknown>): OfferteBewijs | undefined {
  return (verb === 'create_offerte' || verb === 'maak_herhaalofferte') && body.ok === true ? leesOfferteBewijs(body.offerte) : undefined;
}

/** De link blijft ook aanwezig als het model hem vergeet. Geen voorspelde links. */
export function metOfferteLinks(draft: string, acties: Array<{ verb: string; uitkomst?: { besluit: string; ok?: boolean; offerte?: OfferteBewijs } }>): string {
  const links = new Map<string, OfferteBewijs>();
  for (const a of acties) {
    if (a.uitkomst?.besluit !== 'akkoord') continue;
    const o = offerteAanmaakBewijs(a.verb, a.uitkomst as unknown as Record<string, unknown>);
    if (o && !draft.includes(o.url)) links.set(o.id, o);
  }
  if (!links.size) return draft;
  const tekst = [...links.values()].map(o => `Bekijk je offerte ${o.nummer}, kies je pakket en plan direct een ophaalmoment in: ${o.url}`).join('\n\n');
  const afsluiting = /\n\s*\n(?=(?:Met vriendelijke groet(?:en)?|Vriendelijke groet(?:en)?|Hartelijke groet(?:en)?|Groet(?:en)?|Kind regards|Best regards)[,!]?\s*$)/i;
  return afsluiting.test(draft) ? draft.replace(afsluiting, `\n\n${tekst}\n\n`) : `${draft.trimEnd()}\n\n${tekst}`;
}
